import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Eye, EyeOff, CheckCircle2 } from 'lucide-react';
import api from '../utils/api';

/* Elegir una contraseña nueva con el token que llegó por mail */
export default function Recuperar() {
  const token = new URLSearchParams(window.location.search).get('token') || '';
  const [password, setPassword] = useState('');
  const [repetir, setRepetir] = useState('');
  const [ver, setVer] = useState(false);
  const [error, setError] = useState('');
  const [listo, setListo] = useState(false);
  const [guardando, setGuardando] = useState(false);
  const navigate = useNavigate();

  const guardar = async (e) => {
    e.preventDefault();
    setError('');
    if (password !== repetir) return setError('Las dos contraseñas tienen que ser iguales');
    setGuardando(true);
    try {
      await api.post('/auth/recuperar', { token, password });
      setListo(true);
    } catch (err) {
      setError(err?.response?.data?.error || 'No se pudo cambiar la contraseña');
    } finally { setGuardando(false); }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20, background: 'var(--bg-primary)' }}>
      <div className="card" style={{ width: '100%', maxWidth: 400 }}>
        {listo ? (
          <div style={{ textAlign: 'center' }}>
            <CheckCircle2 size={40} color="var(--success)" style={{ marginBottom: 12 }} />
            <h1 style={{ fontSize: 20, fontWeight: 800, marginBottom: 6 }}>Contraseña cambiada</h1>
            <p style={{ fontSize: 13, color: 'var(--text-muted)', marginBottom: 20 }}>Ya podés entrar con la nueva.</p>
            <button className="btn btn-primary" style={{ width: '100%', justifyContent: 'center' }}
              onClick={() => navigate('/login')}>Ir a entrar</button>
          </div>
        ) : !token ? (
          <div style={{ textAlign: 'center' }}>
            <h1 style={{ fontSize: 20, fontWeight: 800, marginBottom: 6 }}>Enlace incompleto</h1>
            <p style={{ fontSize: 13, color: 'var(--text-muted)', marginBottom: 20 }}>
              Abrí el enlace tal como llegó al mail, sin cortarlo.
            </p>
            <button className="btn btn-secondary" style={{ width: '100%', justifyContent: 'center' }}
              onClick={() => navigate('/login')}>Volver</button>
          </div>
        ) : (
          <form onSubmit={guardar}>
            <h1 style={{ fontSize: 21, fontWeight: 800, marginBottom: 5 }}>Elegí una contraseña</h1>
            <p style={{ fontSize: 13, color: 'var(--text-muted)', marginBottom: 18 }}>Al menos 8 caracteres.</p>
            {error && (
              <div style={{ background: 'rgba(239,68,68,0.12)', border: '1px solid rgba(239,68,68,0.32)', color: '#ef4444',
                padding: '10px 12px', borderRadius: 10, fontSize: 13, marginBottom: 14 }}>{error}</div>
            )}
            <div className="form-group">
              <label htmlFor="nueva">Contraseña nueva</label>
              <div style={{ position: 'relative' }}>
                <input id="nueva" type={ver ? 'text' : 'password'} value={password} autoFocus required
                  onChange={e => setPassword(e.target.value)} autoComplete="new-password" style={{ paddingRight: 42 }} />
                <button type="button" onClick={() => setVer(!ver)} aria-label={ver ? 'Ocultar' : 'Mostrar'}
                  style={{ position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)', background: 'none',
                    border: 'none', color: 'var(--text-muted)', cursor: 'pointer', display: 'flex', padding: 2 }}>
                  {ver ? <EyeOff size={17} /> : <Eye size={17} />}
                </button>
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="repetir">Repetila</label>
              <input id="repetir" type={ver ? 'text' : 'password'} value={repetir} required
                onChange={e => setRepetir(e.target.value)} autoComplete="new-password" />
            </div>
            <button type="submit" className="btn btn-primary" disabled={guardando}
              style={{ width: '100%', justifyContent: 'center' }}>
              {guardando ? 'Guardando...' : 'Guardar contraseña'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
